import "./PlanItemComponent.scss";

interface PlanItemProps {
  number: string;
  text: string;
  status: string;
  executor: string;
  deadline: string;
}

const STATUS_LABELS: Record<string, string> = {
  completed: 'Виконано',
  inProgress: 'Виконується',
  notCompleted: 'Не виконано',
  ongoing: 'Постійно',
};

const PlanItemComponent: React.FC<PlanItemProps> = ({number, text, status, executor, deadline}) => {
  return (
    <div className="plan-card">
      <div className="plan-card__header">
        <span className="plan-card__number">{number}</span>
        <span className={`plan-card__badge plan-card__badge--${status}`}>
          {STATUS_LABELS[status] || status}
        </span>
      </div>
      <div className="plan-card__title">{text}</div>
      <div className="plan-card__meta">
        <span className="plan-card__executor">{executor}</span>
        <span className="plan-card__deadline">{deadline}</span>
      </div>
      <div className={`plan-card__status-bar plan-card__status-bar--${status}`} />
    </div>
  );
};

export default PlanItemComponent;
